import React, { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import './Features.css';

function Features() {
  const sectionRef = useRef(null);
  const isVisible = useIntersectionObserver(sectionRef, { 
    threshold: 0.1,  // Lower threshold
    fallback: true   // Add fallback value
  });
  
  const features = [
    {
      image: "/images/Visibility.png",
      title: "Monitor your AI visibility",
      description: "Track where your brand appears in AI responses across different topics, identifying gaps and opportunities. Categories with 15-50% visibility offer the highest optimization potential.",
    },
    {
      image: "/images/ShareOfVoice.png",
      title: "Understand your competition",
      description: "See which competitors are mentioned instead of you and identify quick optimization wins. The larger the 'others' category, the easier it is to gain market share.",
    },
    {
      image: "/images/Prompts.png",
      title: "Track AI conversations",
      description: "Monitor how AI systems discuss your brand including sentiment and context of mentions, allowing you to focus optimization efforts on the queries that matter most.",
    },
    {
      image: "/images/Sources.png",
      title: "Identify sources that help you get featured in AI Search",
      description: "Identify the 80+ URLs that AI references beyond top Google results. Double down on sources that mention you and expand to those that are frequently cited but don't include your brand.",
    },
    {
      image: "/images/Optimization.png",
      title: "Optimize with precision",
      description: "Improve your content's retrieval rate using our AI-first framework built from academic ML research. Think of this as A/B testing for AI.",
    }
  ];

  // Add error boundary or fallback
  if (!features || features.length === 0) {
    return <section className="features features-fallback" />;
  }

  return (
    <section className="features" ref={sectionRef}>
      <div className="features-content">
        {features.map((feature, index) => (
          <div 
            key={index}
            className={`feature-row ${isVisible ? 'visible' : ''}`}
          >
            <div className="feature-text">
              <h2 className="feature-title">{feature.title}</h2>
              <p className="feature-description">{feature.description}</p>
            </div>
            <div className="feature-image-container">
              <img src={feature.image} alt={feature.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;